/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Review_Submit_FailedInputs */

const en_ticket_review_submit_failed = /** @type {(inputs: Ticket_Review_Submit_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to submit review`)
};

const ja_ticket_review_submit_failed = /** @type {(inputs: Ticket_Review_Submit_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`評価の送信に失敗しました`)
};

const fr_ticket_review_submit_failed = /** @type {(inputs: Ticket_Review_Submit_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'envoi de l'évaluation`)
};

const de_ticket_review_submit_failed = /** @type {(inputs: Ticket_Review_Submit_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung konnte nicht abgesendet werden`)
};

/**
* | output |
* | --- |
* | "Failed to submit review" |
*
* @param {Ticket_Review_Submit_FailedInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_submit_failed = /** @type {((inputs?: Ticket_Review_Submit_FailedInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_Submit_FailedInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_submit_failed(inputs)
	if (locale === "ja") return ja_ticket_review_submit_failed(inputs)
	if (locale === "fr") return fr_ticket_review_submit_failed(inputs)
	return de_ticket_review_submit_failed(inputs)
});